<!-- 案例展示 -->
<template>
    <div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="gomodal"
                >新增案例</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="status">
                    <i-switch
                        v-model="row.status"
                        size="large"
                        true-color="#FF761D"
                        :true-value="1"
                        :false-value="0"
                        @on-change="changeStatus(row)"
                    >
                    </i-switch>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button
                            type="primary"
                            ghost
                            label="small"
                            @click="gomodal(row)"
                            >编辑</Button
                        >
                        <Button
                            type="error"
                            ghost
                            label="small"
                            @click="goDel(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="600"
            :mask-closable="false"
        >
            <Form :model="form_item" label-position="right" :label-width="100">
                <FormItem label="案例名称：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="form_item.title"
                        placeholder="请输入案例名称"
                    ></Input>
                </FormItem>
                <FormItem label="排序：">
                    <Input
                        class="w300"
                        type="number"
                        v-model="form_item.sort"
                        placeholder="请输入排序"
                    ></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="tooltip-icon"
                            type="md-help-circle"
                            size="20"
                            color="#FF761D"
                        />
                        <div slot="content">
                            <p>正序，序号越小，越在前面</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="链接：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="form_item.link"
                        placeholder="请输入链接"
                    ></Input>
                </FormItem>
                <FormItem label="案例介绍：">
                    <Input
                        class="w300"
                        type="textarea"
                        v-model="form_item.desc"
                        placeholder="请输入案例介绍"
                    ></Input>
                </FormItem>
                <FormItem label="是否发布：">
                    <i-switch
                        v-model="form_item.status"
                        size="large"
                        true-color="#FF761D"
                        :true-value="1"
                        :false-value="0"
                    >
                    </i-switch>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    cases_list,
    cases_save,
    cases_status,
    cases_delete,
    cases_sort,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
            },
            total: 0,
            columnsTable: [
                { title: "排序", key: "sort", align: "center", width: "100px" },
                { title: "案例名称", key: "title", align: "center" },
                { title: "案例介绍", key: "desc", align: "center" },
                { title: "链接", key: "link", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            form_item: {
                id: "",
                title: "",
                desc: "",
                sort: "",
                status: 0,
                link: "",
            },
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            cases_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        gomodal(row) {
            if (row.id) {
                this.modalTitle = "编辑案例";
                this.form_item.id = row.id;
                this.form_item.title = row.title;
                this.form_item.desc = row.desc;
                this.form_item.sort = row.sort;
                this.form_item.status = row.status;
                this.form_item.link = row.link;
            } else {
                this.modalTitle = "新增案例";
                this.form_item.id = "";
                this.form_item.title = "";
                this.form_item.desc = "";
                this.form_item.status = 0;
                this.form_item.link = "";
                this.getSort();
            }
            this.modals = true;
        },
        getSort() {
            cases_sort().then((res) => {
                this.form_item.sort = res.data;
            });
        },
        // 确定
        submitModal() {
            cases_save(this.form_item)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    cases_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        changeStatus(row) {
            this.$Modal.confirm({
                title: "修改提示",
                content: "确认修改状态吗？",
                onOk: () => {
                    cases_status({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.text-align-right {
    text-align: right;
}
.tooltip-icon {
    margin-left: 10px;
    cursor: pointer;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>